<template>
  <div class="fm-style w-full">
    <form-edit-header v-model="form_name" :flowable="form.type === 'flowform'" active-index="2" />
    <el-container class="fm2-container">
      <el-header height="40px" class="flow-header">
        <el-button size="small" icon="el-icon-upload" type="primary" @click="saveFlow()">保存</el-button>
      </el-header>
      <el-main class="fm2-main">
        <el-container>
          <el-container class="center-container" direction="vertical">
            <el-main>
              <div ref="container" class="h-full" />
            </el-main>
          </el-container>
          <el-aside class="widget-config-container">
            <el-container>
              <!--              <el-header height="45px">-->
              <!--                <div class="config-tab" :class="{active: configTab==='node'}" @click="handleConfigSelect('node')">节点属性-->
              <!--                </div>-->
              <!--                <div class="config-tab" :class="{active: configTab==='flow'}" @click="handleConfigSelect('flow')">流程属性-->
              <!--                </div>-->
              <!--              </el-header>-->
              <el-main class="config-content">
                <node-config ref="nodeConfigForm" :key="form.id" :widgets="form.widgets" :data="nodeData" @update:data="updateData($event)" />
              </el-main>
            </el-container>
          </el-aside>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import LogicFlow, {PolylineEdge, PolylineEdgeModel, RectNode, RectNodeModel} from '@logicflow/core'
import {Control, DndPanel, MiniMap, SelectionSelect} from '@logicflow/extension'
import '@logicflow/core/dist/style/index.css'
import '@logicflow/extension/lib/style/index.css'
import NodeConfig from '@/components/NodeConfig'
import FlowConfig from '@/components/FlowConfig'
import {data2Lf, defaultGraphData, lf2Data} from '@/utils'
import axios from 'axios'
import FormEditHeader from '@/components/FormEditHeader'
import Layout from '@/Shared/Layout'
import zroute from '../../ziggy'

class CustomRectModel extends RectNodeModel {
  getNodeStyle() {
    const style = super.getNodeStyle()
    const properties = this.properties
    // console.log(this.isSelected)
    // console.log(properties);
    if (this.isSelected) {
      style.stroke = '#76BBEB'
      style.fill = '#E3F6FF'
    } else {
      style.stroke = '#E1E3E5'
      style.fill = '#F7F9FE'

    }
    style.strokeWidth = 1
    return style
  }

  getTextStyle() {
    const style = super.getTextStyle()
    style.fontSize = 14
    return style
  }

  initNodeData(data) {
    // console.log("data", data);
    super.initNodeData(data)
    this.width = 160
    this.height = 40
    //if object is empty
    if (typeof data.properties.type === 'undefined') {
      this.properties = {type: 'node', name: this.text.value}
    }
  }
}

class CustomLineModel extends PolylineEdgeModel {
  getEdgeStyle() {
    const style = super.getEdgeStyle()
    const {properties} = this
    if (this.isSelected) {
      style.stroke = '#2991FF'
    } else if (typeof properties.condition !== 'undefined' && typeof properties.condition.cond !== 'undefined') {
      style.stroke = '#AC92EC'
    } else {
      style.stroke = '#0db3a6'
    }
    return style
  }

  getOutlineStyle() {
    const style = super.getOutlineStyle()
    style.stroke = 'red'
    style.hover.stroke = 'red'
    return style
  }
}


export default {
  name: 'WorkFlow',
  components: {
    NodeConfig,
    FlowConfig,
    FormEditHeader,
  },
  layout: Layout,
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      app_id: zroute().params.app_id,
      form_id: zroute().params.form_id,
      form_name: this.form.name,
      nodeData: {},
    }
  },
  watch: {
    nodeData: function (nVal, oVal) {
      console.log('nodeData', nVal, oVal)
    },
  },
  mounted() {
    this.lf = new LogicFlow({
      container: this.$refs.container,
      grid: false,
      plugins: [DndPanel, SelectionSelect, Control, MiniMap],
    })
    this.lf.register({
      type: 'custom-rect',
      view: RectNode,
      model: CustomRectModel,
    })
    this.lf.register({
      type: 'custom-line',
      view: PolylineEdge,
      model: CustomLineModel,
    })
    this.lf.setPatternItems([
      {
        type: 'custom-rect',
        text: '流程节点',
        label: '流程节点',
        icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAABGdBTUEAALGPC/xhBQAAAnBJREFUOBGdVL1rU1EcPfdGBddmaZLiEhdx1MHZQXApraCzQ7GKLgoRBxMfcRELuihWKcXFRcEWF8HBf0DdDCKYRZpnl7p0svLe9Zzbd29eQhTbC8nv+9zf130AT63jvooOGS8Vf9Nt5zxba7sXQwODfkWpkbjTQfCGUd9gIp3uuPP8bZ946g56dYQvnBg+b1HB8VIQmMFrazKcKSvFW2dQTxJnJdQ77urmXWOMBCmXM2Rke4S7UAW+/8ywwFoewmBps2tu7mbTdp8VMOkIRAkKfrVawalJTtIliclFbaOBqa0M2xImHeVIfd/nKAfVq/LGnPss5Kh00VEdSzfwnBXPUpmykNss4lUI9C1ga+8PNrBD5YeqRY2Zz8PhjooIbfJXjowvQJBqkmEkVnktWhwu2SM7SMx7Cj0N9IC0oQXRo8xwAGzQms+xrB/nNSUWVveI48ayrFGyC2+E2C+aWrZHXvOuz+CiV6iycWe1Rd1Q6+QUG07nb5SbPrL4426d+9E1axKjY3AoRrlEeSQo2Eu0T6BWAAr6COhTcWjRaYfKG5csnvytvUr/WY4rrPMB53Uo7jZRjXaG6/CFfNMaXEu75nG47X+oepU7PKJvvzGDY1YLSKHJrK7vFUwXKkaxwhCW3u+sDFMVrIju54RYYbFKpALZAo7sB6wcKyyrd+aBMryMT2gPyD6GsQoRFkGHr14TthZni9ck0z+Pnmee460mHXbRAypKNy3nuMdrWgVKj8YVV8E7PSzp1BZ9SJnJAsXdryw/h5ctboUVi4AFiCd+lQaYMw5z3LGTBKjLQOeUF35k89f58Vv/tGh+l+PE/wG0rgfIUbZK5AAAAABJRU5ErkJggg==',
      },
    ])
    // 添加导航栏
    this.lf.extension.control.addItem({
      iconClass: 'custom-minimap',
      title: '',
      text: '导航',
      onClick: (lf, ev) => {
        const position = lf.getPointByClient(ev.x, ev.y)
        lf.extension.miniMap.show(
          position.domOverlayPosition.x - 120,
          position.domOverlayPosition.y + 35,
        )
      },
    })
    this.lf.extension.control.addItem({
      iconClass: 'fa-trash-o',
      title: '',
      text: '删除',
      onClick: (lf, ev) => {
        const elements = lf.getSelectElements(true)
        lf.clearSelectElements()
        elements.edges.forEach((edge) => {
          lf.deleteEdge(edge.id)
        })

        elements.nodes.forEach((node) => {
          if (node.properties.type === 'node') {
            lf.deleteNode(node.id)
          }
        })
      },
    })
    this.lf.on('node:click,edge:click', (data) => {
      console.log(data)
      this.nodeData = data.data.properties
    })
    this.getWorkFlowList()
  },
  methods: {
    getWorkFlowList() {
      if (this.form) {
        this.lf.render(data2Lf(this.form.flows))
      } else {
        this.lf.render(defaultGraphData)
      }

      // getWorkFlows({form_id: this.$route.params.id}).then(res => {
      //   if (res.length > 0) {
      //     this.lf.render(data2Lf(res));
      //   } else {
      //     this.lf.render(defaultGraphData);
      //   }
      //
      // })
    },
    saveFlow() {
      let graphData = this.lf.getGraphData()
      console.log('graphData', graphData)
      let data = lf2Data(graphData)
      console.log(data)
      axios.post(zroute('app.form.flow.save', [this.app_id, this.form_id]), {data: data, version: 1}).then(res => {
        if (res.data.status === 1) {
          this.$message({
            message: '保存成功',
            type: 'success',
          })
        } else {
          this.$message({
            message: '保存失败',
            type: 'error',
          })
        }
      })
      // saveWorkFlows({data: data, version: 1, form_id: this.$route.params.id}).then(res => {
      //   if (res.status === 1) {
      //     this.$message.success('保存成功');
      //   } else {
      //     this.$message.error('保存失败');
      //   }
      // })
    },
    updateData: function (event) {
      const elements = this.lf.getSelectElements(true)
      if (elements.nodes.length + elements.edges.length !== 1) {
        return
      }

      elements.edges.forEach((edge) => {
        edge.properties = event
        this.lf.setProperties(edge.id, event)
      })

      elements.nodes.forEach((node) => {
        console.log(node)
        this.lf.setProperties(node.id, event)
        const nodeModel = this.lf.getNodeModelById(node.id)
        nodeModel.updateText(event.name)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-minimap {
  background: url(data:image/png;base64,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);
  background-size: 20px 20px;
}

.fa-trash-o {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAABQCAYAAACu/a1QAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAABKlJREFUeJztnE1sFGUYx///mek2KsFDd4diMKbIwfSgN/xGJEYuJtYvPFEXCpSk8aJUpKUWYreJJyVRoEHttoZLY/DjIEoEgomeuGiUaiq0ftDYbguCqch+zOOBVujOu7a78y5LM+/vts/zzH+f/868OzPvzruAwWAwhASWQ7T2vUS9Z8tWgA9CcGupOkKkABzNQfadi+88q7FFALrNH+903JFIF4hWAJYuWQH+BrAt9ULbfpCiS1dbgxBhbCTSD2K7Vl0ABG4msNft627XqWvrEorVVTWS7NClV4A1ixrWHJ76+JiWIaBnD4kQ4DYtWnO9lcb30TLmo8nXV1mwTqhyIhgmkS5aVOQWkMv8cWRzOeeOyU3bR4vvdDZOUAEAsIQtyo9R8HZqQ/uLJYmKMJbs/ojEk7PihGPZ2S0AdpWkew2BD/uad9+4DeDTvoSIwLPeLFmYFAveWwVSzfUDnZGStacJbN6ys1tAxRFEfjbetONMEO2x+M4TIhj0Z1g7ecl5Kog2ENB8/UBnhJRmVc6DvBNEGwBAikD2q1IibAkqH8j8lU+ftb6E4PTEcOaLINozZJDpn77IyYMPu8nE3UG0WdObuMsm1l45XRW7NeIA78kPi8hxAp8GaWyWHrGZYL0/IUcAHC5BLwuJfEi3NzEKYqmOJhcSAjlqhdE4ABBcpvUafKERbvMi+KHSTVSI75w00g9FUL0ScvUoIL17Ae7ylYvsE1javsX147WQfMIX9aSJtP67FyAkcxPSXzsXNuz+E8CRa4uX9HU7Iv45AyFOpeJtn5ejbR24yS6fcQCgY32Vamz7OT8e7jFf6QYqiTEfVoz5sKJlGgudnVbszurlXk4cALBsZlPrd5wuNMe+9GBnNJ2ORGdei5MePbd+90Wldk9PVY09thy2TQCoynmX/tjU8YuOtrXsebcucoCeDNnEoE0M0pOhWF/3XlXtkmTXymw6cnam1iYG7WzVmegHXcobLDcy8aXt2D/O1HqONeL2Jl7W0bemqWs8kh8i8KiyVPAAiVnzbyRrmLV88wLTQqsUMaV2sYR6zBvzYcWYDyvGfFgx5sOKMR9WjPmwYsyHFWM+rBjzYcWYDyvGfFgx5sOKJvPyuy8C+VVZCfzmD4rYnroeAv+qCilQWyR6fqjM8nlUoUEgVQBAMGPneEhVmoq3H3L7Ew0iuH0mJsJvx5vaT6nqxeZqiPf41QemrCnLjgzoaFuL+fHN7WMAeuZVTMo48Ml8tacfJPI9TKQDM+bDijE/b4RlWX6qjSL7U5r34GUK1NcU3dB1RVxV1EvbipUaBcwz56nXrBFrS+6rzKzYs6dawNX5cYFcnlxcN6baRmk+uij3k2pdC4H7YsnEs4E7LQMXF//1ColofpzASaxbl1NtU3CMuMnEAIDnNPZXKV4aj7cr1/cV/MITT72gb0Ehcj5z2X6/ULqg+dTGjm8g0leerq4PBFvPN796oVD+f091tKtbIDipv63yI5ADY/G2gnsdmMP8WGPrVCZtPwaI8iblBsUTke7UcGbrXP+yMO+LArev+34R7xkIV1C1drby/COC70VyByc2vjZU6WYMBoPBcKPwL1M2epONsbRKAAAAAElFTkSuQmCC);

  background-size: 20px 20px;

}

.el-radio-button__inner .el-radio-button--medium {
  width: 200px;
}

$primary-color: #409EFF;
$primary-background-color: #ecf5ff;

.fm-style {
  height: 600px;

  *, :after, :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .fa-icon {
    width: auto;
    height: 1em; /* 或任意其它字体大小相对值 */

    /* 要在 Safari 中正常工作，需要再引入如下两行代码 */
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
  }

  .fm2-container {
    background: #fff;
    height: 100%;
    border: 1px solid #e0e0e0;

    .flow-header {
      line-height: 40px;
      text-align: right;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
      z-index: 1024;
    }

    .el-container {
      height: 100% !important;
    }

    & > .el-container {
      background: #fff;
    }

    .fm2-main {
      position: relative;

      & > .el-container {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }

    main {
      padding: 0;
    }

    footer {
      height: 30px;
      line-height: 30px;
      border-top: 1px solid #e0e0e0;
      font-size: 12px;
      text-align: right;
      color: $primary-color;
      background: #fafafa;

      a {
        color: $primary-color;
      }
    }
  }

  .center-container {
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;

    .btn-bar {
      height: 45px;
      line-height: 45px;
      font-size: 18px;
      border-bottom: solid 2px #e4e7ed;
      text-align: right;
    }

    .el-main {
      padding: 0;
      position: relative;
      background: #fafafa;
    }
  }

  .components-list {
    padding: 8px 0;
    width: 100%;
    height: 100%;

    .widget-cate {
      padding: 8px 12px;
      font-size: 13px;
    }

    ul {
      position: relative;
      overflow: hidden;
      padding: 0 10px 10px;
      margin: 0;
    }

    .form-edit-widget-label {
      font-size: 12px;
      display: block;
      width: 48%;
      line-height: 26px;
      position: relative;
      float: left;
      left: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 1%;
      color: #333;
      border: 1px solid #F4F6FC;

      &:hover {
        color: $primary-color;
        border: 1px dashed $primary-color;
      }

      & > a {
        display: block;
        cursor: move;
        background: #F4F6FC;
        border: 1px solid #F4F6FC;

        .icon {
          margin-right: 6px;
          margin-left: 8px;
          font-size: 14px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
  }

  .widget-form-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;


    .widget-form-list {
      background: #fff;
      // border: 1px dashed #999;
      border: 1px dashed #999;
      min-height: 600px;
      margin: 10px;

      .widget-col-list {
        min-height: 50px;
        border: 1px dashed #ccc;
        background: #fff;
      }

      .widget-view {
        padding-bottom: 18px;
        position: relative;
        border: 1px dashed rgba(170, 170, 170, 0.7);
        background-color: rgba(236, 245, 255, .3);
        margin: 2px;

        .el-form-item__content {
          position: unset;
        }

        &.is_req {
          .el-form-item__label::before {
            content: '*';
            color: #f56c6c;
            margin-right: 4px;
          }
        }

        .widget-view-description {
          height: 15px;
          line-height: 15px;
          font-size: 13px;
          margin-top: 6px;
          color: #909399;
        }

        .widget-view-action {
          position: absolute;
          right: 0;
          bottom: 0;
          height: 28px;
          line-height: 28px;
          background: $primary-color;
          z-index: 9;

          i {
            font-size: 14px;
            color: #fff;
            margin: 0 5px;
            cursor: pointer;

          }
        }

        .widget-view-drag {
          position: absolute;
          left: -2px;
          top: -2px;
          bottom: -18px;
          height: 28px;
          line-height: 28px;
          background: $primary-color;
          z-index: 9;
          // display: none;

          i {
            font-size: 14px;
            color: #fff;
            margin: 0 5px;
            cursor: move;
          }
        }

        &:after {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          display: block;
        }

        &:hover {
          background: $primary-background-color;
          outline: 1px solid $primary-color;
          outline-offset: 0px;

          &.active {
            outline: 2px solid $primary-color;
            border: 1px solid $primary-color;
            outline-offset: 0;
          }

          .widget-view-drag {
            display: block;
          }
        }

        &.active {
          outline: 2px solid $primary-color;
          border: 1px solid $primary-color;
        }

        &.ghost {
          background: #F56C6C;
          border: 2px solid #F56C6C;
          outline-width: 0;
          height: 3px;
          box-sizing: border-box;
          font-size: 0;
          content: '';
          overflow: hidden;
          padding: 0;
        }
      }

      .widget-table {
        padding-bottom: 0;
        padding: 5px;
        background-color: rgba(253, 246, 236, .3);

        .widget-table-wrapper {
          min-height: 50px;
          background: #fff;
          display: flex;
          justify-content: flex-start;

          .widget-table-row {
            td {
              border-bottom: 0;
            }
          }

          .widget-table-left {
            width: 51px;
            border-left: 1px solid #EBEEF5;
            border-right: 1px solid #EBEEF5;
            border-top: 1px solid #EBEEF5;
            flex: none;
          }

          .widget-table-view {
            border: 1px solid #EBEEF5;
            width: 200px;
            float: left;
            height: 100%;
            position: relative;
            display: block;

            .el-table {
              height: 100%;
            }

            &.is_req {
              .el-form-item__label::before {
                content: '*';
                color: #f56c6c;
                margin-right: 4px;
              }
            }

            .widget-view-description {
              height: 15px;
              line-height: 15px;
              font-size: 13px;
              margin-top: 6px;
              color: #909399;
            }

            .widget-view-action {
              position: absolute;
              right: 0;
              bottom: 0;
              height: 28px;
              line-height: 28px;
              background: $primary-color;
              z-index: 9;

              i {
                font-size: 14px;
                color: #fff;
                margin: 0 5px;
                cursor: pointer;

              }
            }

            .widget-view-drag {
              position: absolute;
              left: -2px;
              top: -2px;
              bottom: -18px;
              height: 28px;
              line-height: 28px;
              background: $primary-color;
              z-index: 9;
              // display: none;

              i {
                font-size: 14px;
                color: #fff;
                margin: 0 5px;
                cursor: move;
              }
            }

            &::after {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              display: block;
              content: '';
            }

            &::before {
              display: none;
            }

            &:hover {
              background: $primary-background-color;
              outline: 1px solid $primary-color;
              outline-offset: -1px;

              &.active {
                // outline: 1px solid $primary-color;
                border: 1px solid $primary-color;
                outline: 1px solid $primary-color;
                outline-offset: -1px;
              }

              .widget-view-drag {
                display: block;
              }
            }

            &.active {
              outline: 1px solid $primary-color;
              border: 1px solid $primary-color;
              outline-offset: -1px;
            }

            &.ghost {
              background: #F56C6C;
              outline-width: 0;
              width: 5px !important;
              box-sizing: border-box;
              font-size: 0;
              content: '';
              overflow: hidden;
              padding: 0;
              position: relative;
              outline: none !important;
              border: 0 !important;

              &::after {
                background: #F56C6C;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 9999;
                content: '';
                outline: none;
              }
            }
          }

          .widget-table-content {
            width: 100%;
            // border: 1px dashed #ccc;
            outline: 1px dashed #ccc;
            background: #fff;
            flex: 1;
            margin: 0 1px;
            overflow: auto;

            & > div {
              height: 100%;
            }

            .widget-table-col {
              height: 100%;

              .ghost {
                background: #F56C6C;
                // border: 2px solid #F56C6C;
                position: relative;
                content: '';
                float: left;
                height: 100%;
                width: 5px !important;
                list-style: none;
                font-size: 0;
                overflow: hidden;
                outline: none;

                &::after {
                  background: #F56C6C;
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  z-index: 9999;
                  content: '';
                  outline: none;
                }
              }
            }
          }
        }

        &.active {
          outline: 2px solid #e6a23c;
          border: 1px solid #e6a23c;
        }

        &:hover {
          background: #fdf6ec;
          outline: 1px solid #e6a23c;
          outline-offset: 0px;

          &.active {
            outline: 2px solid #e6a23c;
            border: 1px solid #e6a23c;
            outline-offset: 0;
          }
        }

        .widget-view-action.widget-col-action {
          background: #e6a23c;
        }

        .widget-view-drag.widget-col-drag {
          background: #e6a23c;
        }

        &::after {
          display: none;
        }

        &.ghost {
          background: #F56C6C;
          outline-width: 0;
          height: 5px;
          box-sizing: border-box;
          font-size: 0;
          content: '';
          overflow: hidden;
          padding: 0;
          position: relative;
          outline: none;
          border: 0;

          &::after {
            background: #F56C6C;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            content: '';
            display: block;
            z-index: 999;
          }
        }
      }

      .widget-col {
        padding-bottom: 0;
        padding: 5px;
        // margin-left: 2px !important;
        // margin-right: 2px !important;
        background-color: rgba(253, 246, 236, .3);

        &.active {
          outline: 2px solid #e6a23c;
          border: 1px solid #e6a23c;
        }

        &:hover {
          background: #fdf6ec;
          outline: 1px solid #e6a23c;
          outline-offset: 0px;

          &.active {
            outline: 2px solid #e6a23c;
            border: 1px solid #e6a23c;
            outline-offset: 0;
          }
        }

        .el-col {
          min-height: 50px;
        }

        &.ghost {
          background: #F56C6C;
          border: 2px solid #F56C6C;
          outline-width: 0;
          height: 3px;
          box-sizing: border-box;
          font-size: 0;
          content: '';
          overflow: hidden;
          padding: 0;
        }

        .widget-view-action.widget-col-action {
          background: #e6a23c;
        }

        .widget-view-drag.widget-col-drag {
          background: #e6a23c;
        }

        &::after {
          display: none;
        }
      }

      .ghost {
        background: #F56C6C;
        border: 2px solid #F56C6C;
        outline-width: 0;
        height: 3px;
        box-sizing: border-box;
        font-size: 0;
        content: '';
        overflow: hidden;
        padding: 0;
      }
    }

    .ghost {
      background: #F56C6C;
      border: 2px solid #F56C6C;
      position: relative;

      &::after {
        background: #F56C6C;
      }
    }

    li.ghost {
      height: 5px;
      list-style: none;
      font-size: 0;
      overflow: hidden;
    }

    .widget-grid {
      background: #F4F6FC;
      position: relative;
      border-left: 5px solid transparent;
      padding: 5px;
      margin: 0 !important;

      &.active {
        border-left: 5px solid $primary-color;
        background: #b3d8ff;
      }
    }

    .widget-grid-container {
      &.ghost {
        background: #F56C6C;
        border: 2px solid #F56C6C;
        outline-width: 0;
        height: 3px;
        box-sizing: border-box;
        font-size: 0;
        content: '';
        overflow: hidden;
        padding: 0;
      }
    }

    .ghost {
      background: #F56C6C;
      border: 2px solid #F56C6C;
      position: relative;

      &::after {
        background: #F56C6C;
      }
    }

    li.ghost {
      height: 5px;
      list-style: none;
      font-size: 0;
      overflow: hidden;
    }
  }

  .widget-config-container {
    position: relative;

    .el-header {
      border-bottom: solid 2px #e4e7ed;
      padding: 0 5px;
    }

    .config-tab {
      height: 45px;
      line-height: 45px;
      display: inline-block;
      width: 145px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      position: relative;
      cursor: pointer;

      &.active {
        border-bottom: solid 2px $primary-color;
      }
    }

    .config-content {
      padding: 10px;

      .el-form-item__label {
        padding: 0;
        font-weight: 500;
      }

      .el-form-item {
        border-bottom: solid 1px #e1e1e1;
        padding-bottom: 10px;
      }

      .config-pattern-input {
        .el-input-group__prepend, .el-input-group__append {
          padding: 0 8px;
        }
      }
    }

    .ghost {
      background: #fff;
      border: 1px dashed $primary-color;

      &::after {
        background: #fff;
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }

    ul {
      margin: 0;
      padding: 0;
    }

    li.ghost {
      list-style: none;
      font-size: 0;
      display: block;
      position: relative;
    }
  }

  .viewer-container {
    z-index: 99999 !important;
  }

  .form-empty {
    position: absolute;
    text-align: center;
    width: 300px;
    font-size: 20px;
    top: 200px;
    left: 50%;
    margin-left: -150px;
    color: #ccc;
  }

  .widget-empty {
    background-position: 50%;
  }
}
</style>
